import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

import { BaseResponse } from "../../typings/interfaces";
import { BaseResponseSingle } from "../../typings/interfaces/responses";
import { ICashDrawerReasonResponse } from "../../typings/interfaces/responses/cash-drawer-reason-response";
import {
    GET_ALL_CASH_DRAWER_REASONS,
    ADD_CASH_DRAWER_REASON,
    DELETE_CASH_DRAWER_REASON,
    UPDATE_CASH_DRAWER_REASON,
} from "../../configs/apiConfig";

export const getAllCashDrawerReasonsAction = createAsyncThunk(
    "cash-drawer-reasons/all",
    async (_, { rejectWithValue }) => {
        try {
            const response = await axios.get<BaseResponse<ICashDrawerReasonResponse>>(
                GET_ALL_CASH_DRAWER_REASONS
            );
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const createCashDrawerReasonAction = createAsyncThunk(
    "cash-drawer-reasons/create",
    async (
        {
            storeId,
            merchantId,
            reason,
            type,
        }: { storeId: number; merchantId: number; reason: string; type: string },
        { rejectWithValue }
    ) => {
        try {
            const response = await axios.post<BaseResponseSingle<ICashDrawerReasonResponse>>(
                ADD_CASH_DRAWER_REASON(merchantId, storeId),
                {
                    merchantId,
                    storeId,
                    reason,
                    type,
                }
            );
            return response.data;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const deleteCashDrawerReasonAction = createAsyncThunk<
    boolean,
    { merchantId: number; storeId: number; cashDrawerReasonId: number }
>(
    "cash-drawer-reasons/delete",
    async ({ merchantId, storeId, cashDrawerReasonId }, { rejectWithValue }) => {
        try {
            await axios.delete(DELETE_CASH_DRAWER_REASON(merchantId, storeId, cashDrawerReasonId));
            return true;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);

export const updateCashDrawerReasonAction = createAsyncThunk<
    ICashDrawerReasonResponse,
    {
        merchantId: number;
        storeId: number;
        id: number;
        reason: string;
        type: string;
    }
>(
    "cash-drawer-reasons/update",
    async ({ merchantId, storeId, id, reason, type }, { rejectWithValue }) => {
        try {
            const response = await axios.put<BaseResponseSingle<ICashDrawerReasonResponse>>(
                UPDATE_CASH_DRAWER_REASON(merchantId, storeId),
                {
                    id,
                    merchantId,
                    storeId,
                    reason,
                    type,
                }
            );
            return response.data.body;
        } catch (err: any) {
            return rejectWithValue(err.response?.data || err.message);
        }
    }
);
